import React, { useState } from "react";
import "../styles/Productdetailed.css";
import TestimonialSlider from "../Page-section/Home/TestimonialSlider";
import Productsections from "../Page-section/Home/Productsections";
import Ingredients from "../Page-section/Home/pachancare-ingridients";
import CertificationSection from "../Page-section/Home/certification";
import PachancareConsumeBanner  from "../consume-banner/pachancareconsumerbanner";

import icon1 from "../assets/images/icon1.svg";
import icon2 from "../assets/images/icon2.svg";
import icon3 from "../assets/images/icon3.svg";
import icon4 from "../assets/images/icon4.svg";
import p2 from "../assets/images/ll1.jpeg";
import p8 from "../assets/images/l8.jpeg";
import p9 from "../assets/images/l9.jpeg";

const PaachanCarePowder = () => {
  const [activeImage, setActiveImage] = useState(p2);

  const product = {
    name: "Pachan Care Powder | Helps Relieve Symptoms Acidity and Indigestion",
    price: 1299,
    oldPrice: 1999,
    images: [p2, p8, p9],
    description:
      "Pachan Care Powder is a natural Ayurvedic formulation that helps relieve acidity, gas, and indigestion. It supports healthy digestion, improves gut function, reduces bloating, and promotes overall digestive comfort when taken regularly with a balanced diet.",
    buyLink: "https://0frb0r-9m.myshopify.com/products/medicine-for-gas?utm_source=copyToPasteBoard&utm_medium=product-links&utm_content=web",
  };

  return (
    <>
      <section className="product-details">
        <div className="product-details-wrapper">
          <div className="product-image">
            <div className="main-image">
              <img src={activeImage} alt={product.name} />
            </div>
            <div className="thumbnail-row">
              {product.images.slice(0, 3).map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt="thumb"
                  className={`thumbnail ${activeImage === img ? "active" : ""}`}
                  onClick={() => setActiveImage(img)}
                />
              ))}
            </div>
          </div>
          <div className="product-content">
            <h1>{product.name}</h1>

            <div className="rating">
              <span className="stars">★★★★★</span>
              <span className="reviews">(249)</span>
            </div>

            <p className="description">{product.description}</p>

            <div className="features">
              <div className="feature">
                <img src={icon1} alt="Natural" />
                <span>Promotes Healthy Digestion*</span>
              </div>
              <div className="feature">
                <img src={icon3} alt="Fast Relief" />
                <span>Improves Heart Health*</span>
              </div>
              <div className="feature">
                <img src={icon2} alt="Safe" />
                <span>Promotes Mobility & Flexibility*</span>
              </div>
              <div className="feature">
                <img src={icon4} alt="Ayurvedic" />
                <span>Balances Sugar Levels*</span>
              </div>
            </div>

            <div className="price-row">
              <span className="new-pricee">Rs. {product.price}</span>
              <span className="old-pricee">Rs. {product.oldPrice}</span>
            </div>

            <hr />

            <div className="action-buttons">
              <button className="buy-btn" onClick={() => window.open(product.buyLink, '_blank')}>BUY IT NOW</button>
            </div>
          </div>
        </div>

        <a
          href="https://wa.me/919211710043"
          target="_blank"
          rel="noreferrer"
          className="whatsapp"
        >
          <i className="fab fa-whatsapp"></i>
        </a>
      </section>
      <Ingredients />
      <PachancareConsumeBanner />
      <CertificationSection />
      <TestimonialSlider />
      <Productsections />
    </>
  );
};

export default PaachanCarePowder;